import React from 'react'
import Pagecontainer from '../Pagecontainer'

const Presidentmsg = () => {
    return (
        <>
            <Pagecontainer>
                <div className='flex flex-col items-center justify-center my-10'>
                    <h3 className='text-primary text-center font-sans text-2xl font-bold uppercase'>
                        President's Message {' '}
                        <p className='font-vesper text-base font-medium text-red-700 mt-2'>
                            अध्यक्षको सन्देश
                        </p>
                    </h3>
                    <div className='w-[30px] bg-primary h-[4px] my-2' />
                </div>
                <div className='flex gap-5 md:gap-0 flex-col md:flex-row border w-full p-5 justify-between items-center bg-primary bg-opacity-5'>
                    <div className='md:w-[82%]'>
                        <p className='font-vesper text-justify'>
                            आबद्ध बचत तथा ऋण सहकारी संस्था लि. सहकारीको सिद्धान्त र मूल्यमान्यता अनुरुप वि.सं. २०६९ साल साउन २ गते डिभिजन कार्यलय  भद्रपुरमा दर्ता भएपश्चात समुदायमा आधारित भई संचालनमा रहेको प्रारम्भिक सहकारी संस्था हो। यस संस्था तत्कालिन अवस्थामा नियमित बचतका माध्यमबाट समुदायमा छरिएर रहेको पूँजीलाई संकलन गरी सदस्यहरुको सिमित वित्तीय आवश्यकता पूरा गर्न सहयोग गर्ने उदेश्यका साथ शुरुवात भएको थियो। सुरुवातमा सिमित सदस्यहरुमा केन्द्रित रहि कारोबार गरिरहेकोमा हाल २२०० भन्दा बढि सदस्यहरुको वित्तिय सारथी बन्दै संस्था अघि बढेको छ।  सहकारी ऐन, नियमावली, मापदण्डको दायराभित्र रही समय सापेक्ष नविनतम् सोच र कार्यशैलीलाई अंगिकार गर्दै संस्था सवल र सुरक्षित व्यवसायिक संस्थाको रुपमा स्थापित हुन सफल भएको छ। संस्थाले वित्तीय सेवाको साथसाथै विविध सामाजिक क्रियाकलाप र सेवाहरु प्रदान गर्दै सदस्यमाझ मात्र नभएर समाजमै लोकप्रिय संस्थाको रुपमा समेत पहिचान बनाउन सक्षम भएको हामीले महशुस गरेका छौं। संस्थाको सेवा सुविधालाई अझै परिस्कृत र प्रविधिमैत्री बनाउनेतर्फ आगामी दिनहरुमा हाम्रो अथक प्रयास रहनेछ। सदस्य र समुदायको हितका लागि हामीलाई प्राप्त सल्लाह, सुझावलाई कार्यान्वयनको लागि सदा अग्रसर रहने समेत विश्वास दिलाउन चाहन्छौं।
                            <br /><br />
                            संस्थाबाट पाएको भत्ता समेत साधारण सभामा विपन्न सदस्यलाई वितरण गर्दै सदस्यहरुप्रती सदा सहायता र जिम्मेवार सञ्चालकको रुपमा आफु लागेको र संस्थाका अन्य सञ्चालकहरुपनि संस्थामा निस्वार्थ जोडिनुभएकोले संस्था सदस्य केन्द्रित रहेको कुरा जानकारी गराउन चाहान्छु। संस्थाको परिकल्पना पूरा गर्न प्रत्यक्ष तथा परोक्ष रुपमा निरन्तर सहयोग गर्नुहुने सम्पूर्ण प्रारम्भिक संस्थाहरु, जिल्लास्थित संघहरु, केन्द्रीय संघहरु, राष्ट्रिय सहकारी महासंघ,राष्ट्रिय सहकारी बैंक, वित्तिय साझेदार संस्थाहरु लगायत नियामक निकायहरुप्रति हार्दिक आभार प्रकट गर्दछौं। साथै निरन्तर सहयोग र सद्भावको लागि समेत सम्पूर्ण सरोकारवालाहरुमा हार्दिक अपिल गर्दछौं।
                        </p>
                    </div>
                    <div className='md:w-[18%] flex md:flex-col gap-5 items-center justify-center'>
                        <img
                            className='w-[30%] md:w-[60%] rounded-full ring-4 ring-primary p-[2px]'
                            src={require('../../assets/members/president.png')}
                            alt='president'
                        />
                        <p className='text-center text-primary font-vesper'>
                            <a className='hover:underline' href='https://www.facebook.com/parbatsparsha' target='_blank'>
                                नन्दमान भट्टराई (नरेस)
                            </a>
                            <br />
                            <span className='text-black text-opacity-70 text-sm'>
                                अध्यक्ष, आबद्ध साकोस लि.
                            </span>
                        </p>
                    </div>
                </div>
            </Pagecontainer>
        </>
    )
}

export default Presidentmsg